import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('LabelWithDescription');

export const labelWithDescriptionClassNames = {
  root: factory.root(),
  description: factory.element('description'),
  bottomContent: factory.element('bottom-content'),
  errorMessage: factory.element('error-message'),
  disabled: factory.attribute('disabled'),
};
